export default "__VITE_ASSET__70e33771__"